import React, { useState, MouseEvent } from "react";
import { findSegmentProps } from "../../../../../utils/types";
import { api, getToken } from "../../../../../services/apis/auth-api/apiUrl";
import { ADD_NEW_SUB_SEGMENT_END_POINT } from "../../../../../config/config";
import { AxiosError } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const AddSubSegment : React.FC<findSegmentProps> = ({id, segment_name}) =>{

    const [subSegmentName, setSubSegmentName] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [submitStat, setSubmitStat] = useState({
        submited : false,
        msg : ''
    });

    function saveSubSegmentName (e : MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        if(subSegmentName === '') return setSubmitStat({
            ...submitStat,
            msg : 'Please insert sub-segment name.'
        })
        setLoading(true);
        setTimeout(async()=>{
            try{
                await api.post(ADD_NEW_SUB_SEGMENT_END_POINT, {
                    id : id,
                    segment_name : subSegmentName
                },{
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                setLoading(false);
                setSubmitStat({
                    ...submitStat,
                    submited : true,
                    msg : 'New sub-segment added!'
                })
                setSubSegmentName('')
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    setSubmitStat({
                        ...submitStat,
                        submited : false,
                        msg : 'Unauthorized access!'
                    })
                }else{
                    setSubmitStat({
                        ...submitStat,
                        submited : false,
                        msg : 'An error occured!'
                    })
                }
                setLoading(false);
            }
        },500);
    }
    
    return(
        <div>
            <div>
                Add Sub-Segment for {segment_name}
            </div>
            <div>
                <div className={submitStat.submited ? "text-green-600" :"text-red-500"}>
                    {submitStat.msg}
                </div>
                <form action="">
                    <div>

                    </div>
                    <div className="input-container flex flex-col">
                        <label>Sub-segment name: </label>
                        <input type="text" name="sub_segment_name" value={subSegmentName} onChange={(e)=>setSubSegmentName(e.target.value)} className="text-box" />
                    </div>
                    <div className="input-container">
                        {loading ? (
                            <button type="button" disabled className='button button-disabled'>
                                <FontAwesomeIcon className='animate-spin' icon={faSpinner} />  Processing....
                            </button>
                        ) : (
                            <button type="button" onClick={saveSubSegmentName} className="button button-vcc-primary text-md">
                                Save Sub-Segment
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddSubSegment;